import { KC_Text_Sizes, KC_Weights } from "../../../../designsystem/ds_commons";
import KC_Text from "../../../../designsystem/typography/KC_Text/KC_Text";
import React from "react";
import { tt } from "../../../../utils/i18n/i18n";
import { BASE_URL } from "../../../../utils/constants";
import { SIGNUP } from "../../../../utils/routes/routes";

interface Props {
  onResendMail: () => void;
}

export default function CodeValidationFooter(props: Props) {
  return (
    <KC_Text
      size={KC_Text_Sizes.lg}
      weight={KC_Weights.reg}
      className="text-center"
      text={
        <>
          <span className="d-flex d-md-inline justify-content-center">
            {tt("code_validation_footer_something_wrong")}{" "}
          </span>
          <br className="d-sm-none" />
          <span
            className="text-red cursor-pointer"
            onClick={props.onResendMail}
          >
            <u>{tt("code_validation_footer_resend_email")}</u>
          </span>{" "}
          {tt("code_validation_footer_or")}{" "}
          <a className="text-red" href={`${BASE_URL}${SIGNUP}`}>
            <u>{tt("code_validation_footer_restart")}</u>
          </a>{" "}
          {tt("code_validation_footer_different_address")}
        </>
      }
    />
  );
}
